// extracted by mini-css-extract-plugin
export var growableInput = "_4p-0";
export var tagContainer = "_4p-2";
export var textInput = "_4p-1";